import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertCircle, ArrowLeft, Home, LogOut } from 'lucide-react';
import { useAuthStore } from '@/store/authStore';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { logout } = useAuthStore();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/');
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="flex min-h-screen flex-col bg-[#111] p-6">
      <Card className="mx-auto w-full max-w-4xl border-[#2E3835] bg-card2 text-white">
        <CardHeader className="border-b border-[#2E3835]">
          <div className="flex items-center">
            <AlertCircle className="mr-3 h-8 w-8 text-red-500" />
            <div>
              <CardTitle className="text-2xl text-white">Page Not Found (404)</CardTitle>
              <CardDescription className="text-gray-400">
                The page you are looking for doesn't exist or has been moved
              </CardDescription>
            </div>
          </div>
        </CardHeader>

        <CardContent className="pt-6">
          <div className="mb-6 text-center">
            <div className="mb-4 text-9xl font-bold">404</div>
            <p className="mb-8 text-white">
              We couldn't find the page you were looking for. The page might have been removed,
              renamed, or is temporarily unavailable.
            </p>

            <div className="flex flex-col justify-center gap-4 sm:flex-row">
              <Button
                variant="outline"
                onClick={handleGoBack}
                className="border-[#2E3835] hover:bg-[#2E3835]"
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Go Back
              </Button>
              <Button onClick={handleGoHome} className="bg-[#B7D257] text-black hover:bg-[#D1E47F]">
                <Home className="mr-2 h-4 w-4" />
                Go to Home
              </Button>
              <Button
                variant="outline"
                onClick={handleLogout}
                className="border-red-500 text-red-500 hover:bg-red-500 hover:text-white"
              >
                <LogOut className="mr-2 h-4 w-4" />
                Logout
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
